import { CurrencyPipe } from '@angular/common';
import { Component, ContentChild, Input, OnChanges, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ChartOptions } from 'chart.js';

@Component({
  selector: 'split-bar',
  templateUrl: './split-bar.component.html',
  styleUrls: ['./split-bar.component.scss']
})
export class SplitBarComponent implements OnInit, OnChanges{
 
  basicData: any;

  basicOptions!: ChartOptions; 

  rightpos: any = 0;
  leftpos: any = 0;
  display: any = "none";
  activedText: any = {};



  @Input() columns: Array<any> = [];

  @Input() data: Array<number> = [];
  @Input() colors: Array<String> = [];
  
  @Input() fullData: Array<any> = [];

  @Input() color: String = "#FF8321";
  @Input() tooltipTemplate!: TemplateRef<any> | null;
  @Input() disableCurrency: boolean = false;
  @Input() allowLegend: boolean = false
  
  ngOnInit(): void {}

  pipeCurrency = new CurrencyPipe('pt-Br','BRL');
  constructor() {
  }

  ngOnChanges() {
    this.basicData = {
      labels: this.columns,
      datasets: [
          {
              label: 'Sales',
              data: this.data,
              backgroundColor: this.colors.length > 0 ? this.colors : [this.color],
              borderColor: this.colors.length > 0 ? this.colors : [this.color],
              borderWidth: 1,
              barPercentage: 0.5,
              categoryPercentage: 1
          }
      ]
    };
    let k : boolean = false;
    this.data?.forEach(value => {
      if( Number(value) > 1000) {
        k = true;
      }
    })
    this.basicOptions = {
      onHover: (event: any, elements, chart) => {
        if(elements.length > 0) {
          this.display = 'block';
          this.leftpos = event.x + 'px';
          this.rightpos = event.y + 'px';
          this.activedText.index = elements[0].index;
          this.activedText.title = this.basicData.labels[elements[0].index];
          this.activedText.subtitle = this.basicData.datasets[elements[0].datasetIndex].data[elements[0].index];
        } else {
          this.display = 'none';
        }
      },
      plugins: {
        legend: {
           display: false
        },
        tooltip: {
          enabled: false,
          displayColors: false,
          backgroundColor: '#FFFFFF',
          bodyColor: '#FF7640',
          bodyFont: {
            size: 16,
            weight: 'bold'
          },
          padding: 16,
          titleColor: '#FF8321',
          borderColor: '#F5F5F5',
          borderWidth: 1,
          callbacks: {
            afterBody: function(text: any) {
              return 'R$ ' + text[0].raw;
            }
          }
        }
      },
      scales: {
        y: {
            grid: {
              color: "#F5F5F5"
            },
            ticks: {
                callback: (value : any, index, ticks) => {
                    if(k) {
                      value =  Math.floor(Number(value) / 1000) + 'k';
                    } 
                    return (this.disableCurrency ? ''  : 'R$ ') + value ;
                }

            },
          
        },
        x: {
          display: (!this.allowLegend),
          grid: {
            display: false,
            
          }
        }
    }
    };
  }








}